var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-card-title',[_vm._v("Consultar Caixa")]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }